/**
 * UX-derived agent presence. Not a backend enum — computed from
 * `RpaAgent.isActive` + current `RpaAgentSession`.
 */
export default Object.freeze({
  Disabled: 'disabled',
  Unlinked: 'unlinked',
  Created: 'created',
  Online: 'online',
  Offline: 'offline',
});
